var productName = 'calendar';// region Symlinks ("grunt symlink" task)
export * from './webpack.core.entry.thin.js';
export * from './webpack.grid.entry.thin.js';
export * from './webpack.scheduler.entry.thin.js';
export * from './webpack.engine.entry.js';
// endregion
// region Thin bundle
export * from './webpack.entry.thin.js';
// endregion
// region Class renaming
export {
    // feature
    GroupSummary as GridGroupSummary,
    Summary as GridSummary,
    // export feature
    MultiPageExporter as GridMultiPageExporter,
    MultiPageVerticalExporter as GridMultiPageVerticalExporter,
    PdfExport as GridPdfExport,
    SinglePageExporter as GridSinglePageExporter,
    // feature experimental
    ExcelExporter as GridExcelExporter
} from './webpack.grid.entry.thin.js';
export {
    // features
    GroupSummary,
    Summary,
    // export feature
    MultiPageExporter,
    MultiPageVerticalExporter,
    PdfExport,
    SinglePageExporter,
    // features experimental
    ExcelExporter,
    // feature
    EventEdit as SchedulerEventEdit,
    EventMenu as SchedulerEventMenu,
    EventTooltip as SchedulerEventTooltip,
    ScheduleMenu as SchedulerScheduleMenu,
    // view
    EventEditor as SchedulerEventEditor,
    //view mixin
    EventNavigation as SchedulerEventNavigation,
    EventSelection as SchedulerEventSelection
} from './webpack.scheduler.entry.thin.js';
export {
    // feature
    EventEdit,
    EventMenu,
    EventTooltip,
    ScheduleMenu,
    // view
    EventEditor,
    //view mixin
    EventNavigation,
    EventSelection
} from './webpack.entry.thin.js';
// endregion
